import {
  FacebookLogo,
  GoogleBusinessLogo,
  InstagramLogo,
  LinkedinLogo,
  PinterestLogo,
  SnapchatLogo,
  TiktokLogo,
  TwitterLogo,
  UnknownPlatformLogo,
  YoutubeLogo,
  AddIcon,
} from 'Icons'

import { PropsWithChildren } from 'react'
export interface PlatformIconProps {
  platform?:
    | 'facebook'
    | 'googleBusiness'
    | 'instagram'
    | 'linkedin'
    | 'pinterest'
    | 'snapchat'
    | 'tiktok'
    | 'twitter'
    | 'youtube'
    | 'multiplePlatforms'
}

function PlatformIcon({ platform }: PropsWithChildren<PlatformIconProps>) {
  switch (platform) {
    case 'facebook':
      return <FacebookLogo data-testid="facebook_icon" />
    case 'googleBusiness':
      return <GoogleBusinessLogo data-testid="googlebusiness_icon" />
    case 'instagram':
      return <InstagramLogo data-testid="instagram_icon" />
    case 'linkedin':
      return <LinkedinLogo data-testid="linkedin_icon" />
    case 'pinterest':
      return <PinterestLogo data-testid="pinterest_icon" />
    case 'snapchat':
      return <SnapchatLogo data-testid="snapchat_icon" />
    case 'tiktok':
      return <TiktokLogo data-testid="tiktok_icon" />
    case 'twitter':
      return <TwitterLogo data-testid="twitter_icon" />
    case 'youtube':
      return <YoutubeLogo data-testid="youtube_icon" />
    case 'multiplePlatforms':
      return (
        <AddIcon
          style={{
            width: 16,
          }}
          data-testid="add_icon"
        />
      )
    default:
      return <UnknownPlatformLogo data-testid="unknown_icon" />
  }
}

export default PlatformIcon
